module.exports = __webpack_public_path__ + "img/espacio-honduras.c23a5548.png";